import React from 'react';
import { NavLink } from 'react-router-dom';

import './ApiLink.css';

function getDocsPath(api) {
  return '/services' + api.url.replace('/definitions', '').replace('.json', '');
}

const ApiLink = ({ setSelectedApi, api, isSelected }) => {
  const url = getDocsPath(api);

  return (
    <div>
      <NavLink
        exact
        className="ApiLink"
        activeClassName="ApiLink-selected"
        to={url}>
        {api.name}
      </NavLink>
    </div>
  );
};

export default ApiLink;
